import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-regatta-hall-of-fame',
  imports: [
    MatToolbarModule,
    MatCardModule,
  ],
  templateUrl: './regatta-hall-of-fame.component.html',
  styleUrl: './regatta-hall-of-fame.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegattaHallOfFameComponent {

}
